import { render, staticRenderFns } from "./verify-sms.vue?vue&type=template&id=8fd1b8e2&"
import script from "./verify-sms.vue?vue&type=script&lang=js&"
export * from "./verify-sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports